import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import MemberMembershipService from '../../../../../../services/member_membership_service';
import ConfirmDialog from '../../../../../../components/Common/ConfirmDialog';
import { NeoButton, NeoInput, NeoDatePicker } from '../../../../../../components/Common';
import { formatCurrency } from '../../../../../../utils/format';
import { toISODate, formatDate } from '../../../../../../utils/date';

const ActionCancel = ({ membership, idTenant, user, onRefresh }) => {
    const [isScheduledCancel, setIsScheduledCancel] = useState(false);
    const [cancelDate, setCancelDate] = useState("");
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);

    const handleCancel = async () => {
        if (!reason.trim()) return toast.warning("Informe o motivo.");
        if (isScheduledCancel && !cancelDate) return toast.warning("Informe a data agendada para o cancelamento.");

        const effectiveDate = isScheduledCancel ? cancelDate : toISODate(new Date());

        const ok = await ConfirmDialog({
            title: isScheduledCancel ? "Agendar Cancelamento?" : "Cancelar plano?",
            text: isScheduledCancel
                ? `O plano de "${membership.memberName}" será cancelado automaticamente em ${formatDate(effectiveDate)}.`
                : `Cancelar "${membership.membershipName}" de "${membership.memberName}" agora? Esta ação não pode ser desfeita.`,
            confirmButtonText: "Sim, confirmar!",
            confirmButtonColor: "#dc3545"
        });
        if (!ok) return;

        setLoading(true);
        try {
            await MemberMembershipService.cancel(membership.id, idTenant, user, membership, reason, effectiveDate);
            toast.success(isScheduledCancel ? "Cancelamento agendado." : "Plano cancelado.");
            setCancelDate("");
            setIsScheduledCancel(false);
            setReason("");
            onRefresh?.();
        } catch { toast.error("Erro ao cancelar."); }
        finally { setLoading(false); }
    };

    return (
        <div className="p-4 border mt-3 bg-white shadow-sm" style={{ borderRadius: '12px', borderColor: 'rgba(0, 0, 0, 0.06)', fontFamily: 'Outfit, sans-serif' }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                    <i className="mdi mdi-close-circle-outline fs-4 me-2 text-muted" style={{ color: 'var(--color-brand-secondary) !important' }}></i>
                    <h6 className="fw-bold mb-0 text-uppercase" style={{ letterSpacing: "0.5px", color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                        Cancelar Plano
                    </h6>
                </div>
                <div className="form-check form-switch font-size-12" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    <input className="form-check-input" type="checkbox" role="switch" id="switchSchedCancel"
                        checked={isScheduledCancel} onChange={(e) => setIsScheduledCancel(e.target.checked)} />
                    <label className="form-check-label text-muted ms-1" htmlFor="switchSchedCancel">Agendar futuro?</label>
                </div>
            </div>

            <p className="text-muted font-size-13 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                O cancelamento interromperá os serviços deste aluno. Se não houver data agendada, o contrato é cancelado imediatamente.
            </p>

            {membership.cancellationFee > 0 && (
                <div className="d-flex align-items-center bg-white border p-3 mb-4 shadow-sm" style={{ borderRadius: '12px', borderColor: 'rgba(72, 39, 18, 0.08)', fontFamily: 'Outfit, sans-serif' }}>
                    <i className="mdi mdi-alert-outline fs-5 text-muted mx-2"></i>
                    <div className="flex-grow-1 font-size-12 text-muted">
                        Multa estipulada em contrato: <strong className="text-dark">{formatCurrency(membership.cancellationFee)}</strong>
                    </div>
                    {membership.cancellationNoticeDays > 0 && (
                        <div className="font-size-12 ms-3 pe-2 text-muted">
                            Aviso prévio necessário: <strong className="text-dark">{membership.cancellationNoticeDays} dias</strong>
                        </div>
                    )}
                </div>
            )}

            <Row className="g-3 align-items-start" style={{ fontFamily: 'Outfit, sans-serif' }}>
                <Col md={3}>
                    <NeoDatePicker
                        label="Data Efetiva *"
                        value={isScheduledCancel ? cancelDate : toISODate(new Date())}
                        onChange={date => setCancelDate(date)}
                        disabled={!isScheduledCancel}
                        size="sm"
                    />
                </Col>
                <Col md={5}>
                    <NeoInput
                        label="Motivo *"
                        placeholder="Descreva a razão de saída..."
                        value={reason}
                        onChange={e => setReason(e.target.value)}
                        size="sm"
                    />
                </Col>
                <Col md={4} className="d-flex align-items-end" style={{ height: "62px" }}>
                    <NeoButton
                        variant="danger"
                        onClick={handleCancel}
                        loading={loading}
                        disabled={!reason.trim()}
                        size="sm"
                        className="w-100 mb-0"
                        style={{ height: "36px" }}
                    >
                        Cancelar
                    </NeoButton>
                </Col>
            </Row>
        </div>
    );
};

export default ActionCancel;
